"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonPhotoGrid = exports.PersonPhotoGridDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var person_photo_1 = require("./person-photo");
var number_bubble_1 = require("../elements/number-bubble");
var lodash_1 = require("lodash");
exports.PersonPhotoGridDefaultProps = {
  people: [],
  rows: 3,
  columns: 3,
  size: 24,
  spacing: 6
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  "])))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    box-sizing: border-box;\n    flex-shrink: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    margin: 0;\n    padding: 0;\n\n    ", "\n  "], ["\n    box-sizing: border-box;\n    flex-shrink: 0;\n    list-style: none;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    margin: 0;\n    padding: 0;\n\n    ", "\n  "])), function (_a) {
    var totalWidth = _a.totalWidth,
      totalHeight = _a.totalHeight;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", "px;\n      /* height: ", "px; */\n    "], ["\n      width: ", "px;\n      /* height: ", "px; */\n    "])), totalWidth, totalHeight);
  })
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    margin: 0;\n    padding: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var hspacing = _a.hspacing,
      vspacing = _a.vspacing,
      basis = _a.basis;
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      /* flex-basis: ", "%; */\n      margin-right: ", "px;\n      margin-bottom: ", "px;\n    "], ["\n      /* flex-basis: ", "%; */\n      margin-right: ", "px;\n      margin-bottom: ", "px;\n    "])), basis, hspacing, vspacing);
  }, function (_a) {
    var isLastColumn = _a.isLastColumn;
    return isLastColumn && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-right: 0;\n    "], ["\n      margin-right: 0;\n    "])));
  }, function (_a) {
    var isLastRow = _a.isLastRow;
    return isLastRow && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  })
});
var PersonPhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ExtraCountStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled_components_1.default.ul(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.li(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  PersonPhoto: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PersonPhotoStyles),
  ExtraCount: (0, styled_components_1.default)(number_bubble_1.NumberBubble)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ExtraCountStyles)
};
var PersonPhotoGrid = function (props) {
  var className = props.className,
    rows = props.rows,
    columns = props.columns,
    size = props.size;
  var people = (0, lodash_1.uniqBy)((0, lodash_1.filter)(props.people), function (person) {
    return person.id;
  });
  var hspacing = props.hspacing || props.spacing;
  var vspacing = props.vspacing || props.spacing;
  // if the number of photos exactly matches 
  var showExtras = people.length > rows * columns;
  var maxPhotos = showExtras ? rows * columns - 1 : rows * columns;
  var peopleToShow = people.slice(0, maxPhotos);
  var extras = people.length - peopleToShow.length;
  var basis = 1 / columns * 100;
  var finalRowStartIndex = Math.floor((peopleToShow.length - 1) / columns) * columns;
  var totalWidth = Math.min(columns, showExtras ? peopleToShow.length + 1 : peopleToShow.length) * (size + hspacing) - hspacing;
  var totalHeight = rows * (size + vspacing) - vspacing;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Items, {
    totalWidth: totalWidth,
    totalHeight: totalHeight
  }, peopleToShow.map(function (person, index) {
    return react_1.default.createElement(My.Item, {
      basis: basis,
      isLastRow: index >= finalRowStartIndex,
      isLastColumn: (index + 1) % Math.min(columns, peopleToShow.length + (extras ? 1 : 0)) === 0,
      hspacing: hspacing,
      vspacing: vspacing,
      key: "".concat(index, "-").concat(person.id)
    }, react_1.default.createElement(My.PersonPhoto, {
      size: size,
      entity: person
    }));
  }), !!extras && react_1.default.createElement(My.ExtraCount, {
    size: size,
    text: "+".concat(extras)
  })));
};
exports.PersonPhotoGrid = PersonPhotoGrid;
exports.PersonPhotoGrid.defaultProps = exports.PersonPhotoGridDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;